export default {"src":"/_next/static/media/become-seller.43a21441.svg","height":81,"width":70,"blurWidth":0,"blurHeight":0};